module.exports = __webpack_public_path__ + "static/images/task-red-bg.ddf8a3082.png";